import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import Signin from "../Dashboard/Auth/signin/signin";
import { useAuth } from "../Dashboard/Auth/AuthContext";
import PageNotFound from "../PageNotFound/PageNotFound";
import Settings from "../Dashboard/pages/settings/settings";
import Loading from "../MainWebsite/Components/Loading/Loading";
import Categories from "../Dashboard/pages/category/Categories";
import Brands from "../Dashboard/pages/brand/Brands";
import Products from "../Dashboard/pages/product/Products";
import ProductListContents from "../Dashboard/pages/ProductListContent/ProductListContent";
import ProductImages from "../Dashboard/pages/ProductImages/ProductImages";
import FAQs from "../Dashboard/pages/FAQ/FAQs";
import Contact from "../Dashboard/pages/Contact/Contact";
import HomePage from "../Dashboard/pages/HomePage/HomePage";

function DashboardRoutes() {
  const { isLoggedin, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <Loading />;
  }
  if (!isLoggedin && location.pathname !== "/dashboard/signin") {
    return <Navigate to="/dashboard/signin" replace />;
  }

  if (isLoggedin && location.pathname === "/dashboard") {
    return <Navigate to="/dashboard/" replace />;
  }

  return (
    <Routes>
      {isLoggedin ? (
        <>
          {/* <Route  element={<Index />} /> */}
          <Route path="settings" element={<Settings />} />
          {/* <Route index element={<Index />} /> */}
          <Route path="categories" element={<Categories />} />
          <Route path="brands" element={<Brands />} />
          <Route index path="products" element={<Products />} />
          <Route
            path="product-list-contents"
            element={<ProductListContents />}
          />
          <Route path="product-images" element={<ProductImages />} />
          <Route path="faqs" element={<FAQs />} />
          <Route path="contact" element={<Contact />} />
          <Route path="homepage" element={<HomePage />} />
          {/* <Route index element={<Projects />} /> */}
          {/* 
        
          <Route path="aboutus" element={<AboutUsDashboard />} />
         
          <Route path="clients" element={<Clients />} />
         
          <Route path="project-videos" element={<ProjectVideos />} /> */}
        </>
      ) : (
        // If the user is not logged in, redirect to the sign-in page
        <Route path="*" element={<Navigate to="signin" />} />
      )}
      <Route path="signin" element={<Signin />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default DashboardRoutes;
